import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  CalendarCheck,
  Calendar,
  ArrowLeftRight,
  MoreHorizontal,
} from 'lucide-react';
import { useSidebar } from './Layout';
import { useTutorial } from '../../contexts/TutorialContext';
import { useCongregation } from '../../contexts/CongregationContext';

const mobileNavItems = [
  { name: 'Home', href: '/', icon: LayoutDashboard, id: 'nav-dashboard' },
  { name: 'Rooster', href: '/mijn-rooster', icon: CalendarCheck, id: 'nav-mijn-rooster' },
  { name: 'Beschikbaar', href: '/beschikbaarheid', icon: Calendar, id: 'nav-beschikbaarheid' },
  { name: 'Ruilen', href: '/ruilverzoeken', icon: ArrowLeftRight, id: 'nav-ruilverzoeken' },
];

export default function MobileNav() {
  const { toggle } = useSidebar();
  const { showBadge, dismissBadge } = useTutorial();
  const { active } = useCongregation();

  const color = active?.color || '#4FA79A';

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E7EB] lg:hidden z-30 safe-area-bottom" style={{ boxShadow: '0 -1px 6px rgba(17,24,39,0.06)' }}>
      <div className="flex items-center justify-around h-16">
        {mobileNavItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            onClick={() => item.id && dismissBadge(item.id)}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 h-full px-2 transition-colors relative ${
                isActive ? '' : ''
              }`
            }
            style={({ isActive }) => isActive ? { color } : { color: '#6B7280' }}
          >
            <div className="relative">
              <item.icon className="w-5 h-5" />
              {item.id && showBadge(item.id) && (
                <span className="absolute -top-1 -right-1 w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: 'var(--color-primary)' }} />
              )}
            </div>
            <span className="text-[10px] mt-1 font-medium">{item.name}</span>
          </NavLink>
        ))}
        <button
          onClick={toggle}
          className="flex flex-col items-center justify-center flex-1 h-full px-2 transition-colors"
          style={{ color: '#6B7280' }}
        >
          <MoreHorizontal className="w-5 h-5" />
          <span className="text-[10px] mt-1 font-medium">Meer</span>
        </button>
      </div>
    </nav>
  );
}
